export const remapDeprecatedColors = (color) => {
    const mapping = {
        lava10: 'cream',
        ocean10: 'acidWash',
        sun10: 'neutral200',
        white: 'neutral100',
    };
    return mapping[color] || color;
};
export const breakpoints = {
    tablet: 768,
    desktop: 1230,
};
//# sourceMappingURL=TestimonialMapping.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
